import { defineStore } from 'pinia'
import LangType from '@/utils/i18n/LangType'

const lang = navigator.language.slice(0, 2)
export const useSettingStore = defineStore('sysSetting', {
  state: () => ({
    collapsed: false,
    visitorId: '',
    openKeys: [] as (number | string)[],
    selectedKeys: [] as (number | string)[],
    locale: (LangType[lang] ? lang : 'en') as keyof typeof LangType,
    /**翻译数据json */
    langJson: {} as Record<keyof typeof LangType, any>,
    station: {
      print: '',
      printer: '',
      template: 1,
      language: 'CN',
      isShowLogo: true
    } as Record<string, any>,
    lodopStatus: false as boolean,
    pendingCountData: [] as string[]
  }),
  getters: {
    getCollapsed: (state) => state.collapsed,
    getOpenKeys: (state) => state.openKeys,
    getSelectedKeys: (state) => state.selectedKeys,
    getStation: (state) => state.station
  },
  actions: {
    setVisitorId(id: string) {
      this.visitorId = id
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    setOpenkeys(keys: (number | string)[]) {
      if (this.openKeys.length) return
      this.openKeys = keys
    },
    setSelectedKeys(keys: (number | string)[]) {
      this.selectedKeys = keys
    }
  },
  persist: {
    storage: localStorage,
    paths: ['collapsed', 'locale', 'langJson', 'station']
  }
})
